import { FormatNumberWithCommas } from "../../../../../../shared/scripts/number-functions";
import { TableColumnGroup, TableColumnVisibilityController } from "../../../../../../shared/scripts/table-column-visibility";
import { RenderDateMDY, RenderDateYMD } from "../../../../../../shared/scripts/table-functions";
import { SiteMilestone } from "../../scripts/site-activation.entities";

export class MilestoneDetailsTab {

    tableId: string = "site-milestones-table";
    tableWrapperId: string = this.tableId + "_wrapper";
    dataTable: any;
    tableColumnController: TableColumnVisibilityController;

    constructor(milestones: SiteMilestone[]) {

        let overallMilestones = milestones.filter(m => m.AppendixA == 1 && m.AppendixB == 1);

        let columns: any[] = [
            { data: { _: "SiteNameDisplay", sort: "SiteName" }, title: "Site Name", className: "text-left font-size12" },
            { data: { _: "SiteNumberDisplay", sort: "SiteNumber" }, title: "Site Id", className: "site-id text-center font-size12 nowrap" },
            { data: "PrimeContract", title: "Platform", className: "prime-contract text-center font-size12 nowrap" },
            { data: "Milestone", title: "Milestone", className: "milestone text-left font-size12 nowrap" },
            { data: "DateCompletion", title: "Completion Date", className: "completion-date text-center font-size12 nowrap", render: RenderDateMDY },
            { data: { _: "InPlayDisplay", sort: "InPlay" }, title: "In-Play", className: "in-play text-center font-size12 nowrap" },
            { data: { _: "CommentDisplay", sort: "Comment" }, title: "Comments", className: "comments text-left font-size12" },
            { data: "OrderBy", title: "OrderBy", visible: false },
        ];

        this.dataTable = $('#' + this.tableId).DataTable({
            "dom": '<"top-controls"<"column-select"><"search-bar"f><"spacer"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: true,
            pagingType: 'simple',
            pageLength: 50,
            search: true,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 1
            },
            columns: columns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                }
            ],
            order: [[1, 'asc'], [7, 'asc']],
            data: overallMilestones
        });

        $("#" + this.tableWrapperId + " .top-controls").addClass('row mx-0');

        $("#" + this.tableWrapperId + " .column-select").addClass('col-12 col-md-3 px-0');
        $("#" + this.tableWrapperId + " .column-select").empty().html('<div id="' + this.tableId + '-column-select"></div>');

        $("#" + this.tableWrapperId + " .search-bar").addClass('col-12 col-md-3');

        $("#" + this.tableWrapperId + " .spacer").addClass('col-12 col-md-3');
        $("#" + this.tableWrapperId + " .count-found").addClass('col-12 col-md-3 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $("#" + this.tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"' + this.tableId + '-found-count\"></span></div>');
        $("#" + this.tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        this.tableColumnController = new TableColumnVisibilityController(this.tableId, (this.tableId + '-column-select'), [
            new TableColumnGroup("Site Number", true, [], "site-id"),
            new TableColumnGroup("Platform", true, [], "prime-contract"),
            new TableColumnGroup("Milestone", true, [], "milestone"),
            new TableColumnGroup("Completion Date", true, [], "completion-date"),
            new TableColumnGroup("In-Play", false, [], "in-play"),
            new TableColumnGroup("Comments", true, [], "comments"),
        ]);

        $('#' + this.tableId).on('search.dt', (e, settings) => {
            this.setCountFoundLabel(this.dataTable.rows({ search: 'applied' }).count());
        });
        this.setCountFoundLabel(milestones.length);
    }

    setCountFoundLabel(count: number): void {

        switch (count) {
            case 0: $('#' + this.tableId + '-found-count').text("No Milestones Found"); break;
            case 1: $('#' + this.tableId + '-found-count').text("1 Milestone Found"); break;
            default: $('#' + this.tableId + '-found-count').text(FormatNumberWithCommas(count + "") + " Milestones Found");
        }
    }

    refresh(): void {
        this.dataTable.columns.adjust();
        this.tableColumnController.refresh();
    }

    updateContent(matchingContracts: SiteMilestone[]): void {
        let overallMilestones = matchingContracts.filter(m => m.AppendixA == 1 && m.AppendixB == 1);
        this.dataTable.clear();
        this.dataTable.rows.add(overallMilestones).draw();
        this.setCountFoundLabel(overallMilestones.length);
    }

    clearSearchBar(): void {
        this.dataTable.search('').draw();
    }
}